// import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';

import './scss/front-modules.scss';
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'react-quill/dist/quill.snow.css';
// import './tailwind.scss';

import { I18nContext } from 'core/context/i18n';
import axios from 'axios';
import { setENV } from 'environment';

import App from 'core/app';

import es from 'lang/es.json';
import en from 'lang/en.json';
import { Provider } from 'react-redux';
import store from 'core/store/store';
import useTranslation from 'core/i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const dict = { en, es };

function initProject() {
  const externalAccess = window?.location?.href.includes(
    'https://helio.axpoiberia.es'
  );
  return axios
    .get('/environment.json')
    .then((res) => {
      if (externalAccess) {
        window.environment = setENV('external');
      } else {
        window.environment = setENV(res);
      }
    })
    .catch(() => {
      window.environment = setENV('default');
    })
    .finally(() => {
      ReactDOM.render(<Render />, document.getElementById('root'));
    });
}

function Render() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
  return (
    <Provider store={store}>
      <I18nContext languages={dict} initialize="es">
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </I18nContext>
    </Provider>
  );
}

initProject();
